import Dayjs from 'dayjs'

export default {
  name: 'BriqueChartModalDataGrid',
  inheritAttrs: false, // 부모 Component에서 지정한 Element 속성을 무시 - vue 파일의 다음 구분 참조(v-bind="$attrs", v-on="$listeners"
  props: {
    visible: {
      type: Boolean,
      default: true,
      required: false
    },
    parentChartData: {
      type: Array,
      required: true
    },
    parentChartTitle: {
      type: String,
      required: true
    }
  },
  watch: {
    visible (value) {
      if (value) {
        console.time('parentChartData')
        this.loadGridData(this.parentChartData)
        console.timeEnd('parentChartData')
      }
    },
    columns: {
      deep: true,
      handler () {
        if (this.gridApi !== null) {
          this.setColumns()
        }
      }
    },
    allDataVisible () {
      this.loadGridData(this.parentChartData)
    }
  },
  methods: {
    /**
     * Grid Column settting
     */
    setColumns () {
      this.$refs.chartDataGrid.gridApi.setColumnDefs(this.columns)
    },
    /**
     * Grid data load
     * @param {*} chartData chart data
     */
    loadGridData (chartData) {
      if (chartData.length > 0) {
        if (this.gridApi === null) {
          this.gridApi = this.$refs.chartDataGrid.gridApi
        }
        // 임시로 grid 내부에 loading overlay display
        this.gridApi.showLoadingOverlay()
        // loading overlay 적용으로 인한 timeout 적용
        this.timeout = setTimeout(() => {
          // columns data 생성
          let boxTypeCheck = false
          let columns = chartData.map(c => {
            if (!boxTypeCheck && c.type === 'box') boxTypeCheck = true
            return {
              headerName: c.name,
              field: c.name.replaceAll('.', '')
            }
          })
          columns.unshift({
            headerName: boxTypeCheck ? 'index' : 'x',
            field: 'x'
          })

          // default column setting
          if (this.defColumns.length === 0) {
            let defColumns = this.gridApi.getColumnDefs()
            this.defColumns = defColumns
          }
          for (let column of this.defColumns) {
            columns.unshift(column)
          }
          this.columns = columns

          // grid data 생성
          let gridData = []
          // let currentCount = 0
          for (let data of chartData) {
            let seriesName = data.name.replaceAll('.', '')

            let x = data.x
            let y = data.y
            let limitCount = this.allDataVisible ? y.length : this.dataLimit
            for (let i = 0, max = limitCount; i < max; i++) {
              let xData = boxTypeCheck ? i : x[i]
              if (xData instanceof Date) {
                xData = Dayjs(xData).format('YYYY-MM-DD HH:mm:ss.SSS')
              }
              let idx = gridData.findIndex(row => row.x === xData)
              if (idx < 0) {
                let row = {}
                row['x'] = xData
                row[seriesName] = y[i]
                gridData.push(row)
              } else {
                gridData[idx][seriesName] = y[i]
              }
            }
          }

          this.rowData = this.allDataVisible ? gridData : gridData.slice(0, this.dataLimit)
          this.gridApi.showLoadingOverlay()
        }, 50)
      }
    },
    /**
     * Data limit apply
     */
    applyGridData () {
      this.loadGridData(this.parentChartData)
    },
    /**
     * Excel Csv
     * 조회된 결과를 Csv 파일로 저장합니다.
     * TODO: 현재 사용하지 않음
     */
    exportCsv () {
      this.$refs.chartDataGrid.gridApi.exportDataAsCsv({
        fileName: 'ChartData.csv'
      })
    },
    /**
     * Modal data 초기화
     */
    resetModalData () {
      // this.gridApi = null
      // this.defColumns = []
      this.columns = []
      this.rowData = []
      this.dataLimit = 1000
      this.allDataVisible = false
      if (this.timeout !== null) {
        clearTimeout(this.timeout)
        this.timeout = null
      }
    }
  },
  data () {
    return {
      gridApi: null, // grid api
      columns: [], // grid column 배열
      defColumns: [], // default grid column 배열
      defaultColDef: { // grid column default 설정
        flex: 1,
        minWidth: 100,
        filter: true,
        resizable: true
      },
      rowData: [], // grid row data
      dataLimit: 1000, // data limit count
      allDataVisible: false, // data all visible 여부
      timeout: null // timeout id
    }
  }
}
